import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./ServiceOffering.css";

const ServiceOffering = () => {
  return (
    <>
      <div className="container ServiceOffering mb-0">
        <div className="row">
          <div className="col-md-12">
            <h1 className="headings text-center fs8">
              <span>Exceptional Services</span> for Corporate Travelers
            </h1>
          </div>
        </div>
      </div>
      <div className="offerings details-section">
        <div className="container mt-2">
          <div className="row">
            <div className="col-md-6 col-lg-3 col-6 mt-md-3 mb-lg-5 d-flex justify-content-center padding">
              <div className="box1 office">
                <div className="d-flex flex-column pb-4 mt-xxl-5 mt-md-4 pt-5">
                  <h4 className="headings text-center first-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Group Bookings
                  </h4>
                  <p className="text-center mt-1">
                    Simplify your team’s business travel with our seamless group
                    booking solutions.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6 mt-md-3 mb-lg-5 d-flex justify-content-center padding">
              <div className="box1 phone">
                <div className="d-flex flex-column pb-4  mt-xxl-5 mt-md-4 pt-5">
                  <h4 className="headings text-center second-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Custom Itineraries
                  </h4>
                  <p className="text-center mt-1">
                    Enjoy customized travel plans designed to meet your unique
                    business needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6 mt-md-3 mb-lg-5 d-flex justify-content-center mt-md-4  padding">
              <div className="box1 email">
                <div className="d-flex flex-column mt-xxl-5 mt-md-4 pt-5 pb-4">
                  <h4 className="headings text-center third-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    VIP Travel Services
                  </h4>
                  <p className="text-center mt-1">
                    Upgrade your travel experience with our luxurious VIP
                    services.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6 mt-md-3 mb-lg-5 d-flex justify-content-center mt-md-4 padding">
              <div className="box1 website">
                <div className="d-flex flex-column mt-xxl-5 mt-md-4 pt-5 pb-4">
                  <h4 className="headings text-center fourth-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    24/7 Support
                  </h4>
                  <p className="text-center mt-1">
                    Receive excellent support with our dedicated,
                    around-the-clock assistance for emergencies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceOffering;
